Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.TicketCountCardView extends Backbone.View
  template: JST['backbone/templates/customer_visual_mode/charts/ticket_count/ticket_count_card']
  className: 'ticket-count-card'

  events:
    'click': '_onClick'

  initialize: ({clickable, count, iconClass, statusClass, title, id, precision, unit}) ->
    @clickable = clickable
    @count = count
    @iconClass = iconClass
    @statusClass = statusClass
    @title = title
    @id = id
    @unit = unit || ''
    @precision = precision || 0

  render: ->
    @$el.html @template
      clickable: @clickable
      count: @count
      precision: @precision
      unit: @unit
      iconClass: @iconClass
      title: @title
    @$el.addClass(@statusClass)
    @$el.addClass('clickable') if @clickable
    @

  _onClick: ->
    return unless @clickable
    @trigger('ticketCountCard:click', @id)
